import { BarList as BarListPrimitive } from '@zippeditoolsjs/dashboards';
import { Box, Typography } from '@mui/material';

/**
 * Generic BarList wrapper using Tremor via @zippeditoolsjs/dashboards.
 *
 * Props:
 *   data        - array of raw data objects
 *   nameKey     - field name for the bar label (mapped to Tremor's "name")
 *   valueKey    - field name for the bar value (mapped to Tremor's "value")
 *   title       - optional chart title
 *   tremorConfig - any extra props spread directly onto BarList
 */
export default function BarList(props) {
  const {
    data,
    nameKey = 'name',
    valueKey = 'value',
    title,
    tremorConfig = {},
  } = props;

  if (!data || data.length === 0) return null;

  // Tremor BarList expects items shaped as { name, value }
  const normalized =
    nameKey === 'name' && valueKey === 'value'
      ? data
      : data.map(item => ({ name: item[nameKey], value: item[valueKey] }));

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <BarListPrimitive data={normalized} {...tremorConfig} />
    </Box>
  );
}
